/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type GetStakingInfoQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetStakingInfoQuery = {
	__typename?: "Query";
	hasHistory: boolean;
	assetConfig: {
		__typename?: "AssetConfigResponse";
		stakingEnabled?: boolean | null;
		enabledForUserCountry?: boolean | null;
	};
};

export const GetStakingInfoDocument = gql`
	query getStakingInfo {
		assetConfig {
			stakingEnabled
			enabledForUserCountry
		}
		hasHistory
	}
`;

@Injectable({
	providedIn: "root"
})
export class GetStakingInfoGQLService extends Apollo.Query<GetStakingInfoQuery, GetStakingInfoQueryVariables> {
	document = GetStakingInfoDocument;
	client = "staking";
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
